import axios from 'axios';
import { describeError } from '../utils/errorLog';
import {
  formatYouTubeDuration,
  youtubeDurationFields,
} from './youtubeDuration';

const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
const BASE_URL = 'https://www.googleapis.com/youtube/v3';

export const formatDuration = (duration) => formatYouTubeDuration(duration);

// Search function with pagination support
export const searchMusic = async (query, pageToken = '') => {
  try {
    const response = await axios.get(`${BASE_URL}/search`, {
      params: {
        part: 'snippet',
        maxResults: 10,
        q: query + ' music',
        type: 'video',
        videoCategoryId: '10',
        key: API_KEY,
        pageToken
      }
    });

    const videoIds = response.data.items.map(item => item.id.videoId).join(',');

    const detailsResponse = await axios.get(`${BASE_URL}/videos`, {
      params: {
        part: 'contentDetails,statistics',
        id: videoIds,
        key: API_KEY
      }
    });

    const results = response.data.items.map((item, index) => ({
      id: item.id.videoId,
      title: item.snippet.title,
      artist: item.snippet.channelTitle,
      thumbnail: item.snippet.thumbnails.medium.url,
      ...youtubeDurationFields(
        detailsResponse.data.items[index]?.contentDetails?.duration,
      ),
      views: parseInt(detailsResponse.data.items[index].statistics.viewCount).toLocaleString(),
      addedAt: new Date().toISOString(),
      addedBy: null
    }));

    return {
      results,
      nextPageToken: response.data.nextPageToken || null
    };
  } catch (error) {
    // Summary only: an axios error carries the request URL, which carries the key.
    console.error('YouTube API Error:', describeError(error));
    throw error;
  }
};

// Get individual video details
export const getVideoDetails = async (videoId) => {
  try {
    const response = await axios.get(`${BASE_URL}/videos`, {
      params: {
        part: 'snippet,contentDetails,statistics',
        id: videoId,
        key: API_KEY
      }
    });

    const video = response.data.items[0];
    return {
      id: video.id,
      title: video.snippet.title,
      artist: video.snippet.channelTitle,
      thumbnail: video.snippet.thumbnails.medium.url,
      ...youtubeDurationFields(video.contentDetails?.duration),
      views: parseInt(video.statistics.viewCount).toLocaleString(),
      description: video.snippet.description
    };
  } catch (error) {
    console.error('YouTube API Error:', describeError(error));
    throw error;
  }
};
